import React from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

import CartComponent from 'wave_solder_pallets/components/Cart';
import { changeParameter, validator, updateQuantity, updateValidatorFlag } from 'wave_solder_pallets/store/slice';
import { selectDataForCart } from 'wave_solder_pallets/store/selectors';
import { addToCart } from 'wave_solder_pallets/store/thunks';

const Cart = () => {
  const dispatch = useDispatch();

  const {
    quantity,
    parameters,
    quote,
    addingToCart,
  } = useSelector(selectDataForCart);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
  };

  const onChangeQuantity = (value) => {
    dispatch(updateQuantity(value));
    onChangeParameter('quantities', [value]);
  };


  const onAddToCart = async () => {
    try {
      if (validator.allValid()) {
        await dispatch(addToCart()).unwrap();

        // eslint-disable-next-line no-undef
        window.location.href = '/cart';
      } else {
        validator.showMessages();
        dispatch(updateValidatorFlag());
        toast(Spree.translations.project_errors, { type: 'error' });
      }
    } catch (e) {
      toast(Spree.translations.add_to_cart_error, { type: 'error' });
    }
  };

  return (
    <CartComponent
      parameters={parameters}
      quote={quote}
      quantity={quantity}
      onChangeParameter={onChangeParameter}
      onChangeQuantity={onChangeQuantity}
      onAddToCart={onAddToCart}
      addingToCart={addingToCart} />
  );
};

export default Cart;